(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("lj8Ba", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $79efbc281c3cde86$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $79efbc281c3cde86$var$Loader = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
        className: "lds-ring"
    });
};
var $79efbc281c3cde86$export$2e2bcd8739ae039 = $79efbc281c3cde86$var$Loader;

});

})();
//# sourceMappingURL=Loader.673c5b44.js.map
